import React from "react";
import { Image } from "semantic-ui-react";
import { useTranslation } from "react-i18next";

const DealerOfficeLogoViewForm = ({ ...formProps }) => {
    
  const  { t }  = useTranslation('supplierOffices', { keyPrefix:'supplierLogo'});
  
  return(
  <div className="no-disable-box">
    <b>{t("title")}</b>
    {formProps.value.logoUrl ? (
      <div>
        <Image src={formProps.value.logoUrl} />
      </div>
    ) : (
      <div>{t("noLogoAvailable")}</div>
    )}
  </div>
)};

export default DealerOfficeLogoViewForm;
